import { IEventTravelLegParams } from "Bands/types";

export const getTravelLegTitle = (
  {
    type,
    flightNumber,
    carrierNumber,
    transportMode,
    airline,
    company,
  }: IEventTravelLegParams,
  index?: number
) => {
  const title = flightNumber || carrierNumber || transportMode;
  const subTitle = airline || company;

  const cleanType = type?.replace("event", "").replace("TravelLeg", "");
  const prefix = index ? `#${index} ${cleanType}` : cleanType;

  return {
    prefix,
    title: title || subTitle || prefix,
    subTitle: title ? subTitle : null,
  };
};
